import React, { useEffect } from 'react';
import { useMobile } from '../../../hooks/useMobile';
import { Typography } from '@material-ui/core';
import { useForm, useWatch } from 'react-hook-form';
import {
  useGetStartedContext,
  useEventTrackerContext,
} from '../../../contexts';
import { PlatformProps } from './types/platform-props';
import makeStyles from '@material-ui/core/styles/makeStyles';
import InputTextField from '../../BuildingBlocks/Form/TextField';
import GetStartedTemplate from './GetStartedTemplate';
import RadioGroup from '../../BuildingBlocks/Form/RadioGroup';

const useStyles = makeStyles((theme: any) => ({
  freeText: {
    marginTop: theme.spacing(4),
  },
}));

const TITLE =
  'We are e-comm experts, here to fund sellers like you to scale your e-comm business.';

const SUBTITLE = 'What platform do you sell on primarily?';

export default function Platform({
  progressBarPath = undefined,
  continuePath,
  firstPage = false,
  questions = {},
}: PlatformProps) {
  const classes = useStyles();
  const mobile = useMobile();
  const {
    setValue,
    control,
    handleSubmit,
    register,
    formState: { errors },
  } = useForm();
  const selectedOption = useWatch({ control, name: 'platform' });
  const platformWatch = useWatch({ control, name: 'platformName' });
  const { platform, setPlatform } = useGetStartedContext();
  const { trackEvent } = useEventTrackerContext();

  useEffect(() => {
    if (platform) setValue('platform', platform);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (selectedOption) {
      setPlatform(selectedOption);
      if (selectedOption) {
        trackEvent({
          event: 'selected_store_type',
          store_type: selectedOption,
        });
      }
    }
    // eslint-disable-next-line
  }, [selectedOption]);

  const otherSelected =
    selectedOption === questions?.other?.id &&
    questions?.other?.id !== undefined;

  return (
    <GetStartedTemplate
      title={TITLE}
      subtitle={SUBTITLE}
      progressBarPath={progressBarPath}
      continuePath={continuePath}
      control={control}
      setValue={setValue}
      handleSubmit={handleSubmit}
      firstPage={firstPage}
      disable={!selectedOption || (otherSelected && !platformWatch)}
    >
      <RadioGroup
        groupId={'platform'}
        options={Object.values(questions)}
        setValue={setValue}
        useWatch={useWatch}
        control={control}
        itemPerRow={mobile ? 2 : 3}
        buttonContentDirection="column-reverse"
      />
      {otherSelected && (
        <div className={classes.freeText}>
          <Typography variant={'h6'} gutterBottom>
            Please enter the platform below:
          </Typography>
          <InputTextField
            errors={errors}
            label={'Platform name'}
            name={'platformName'}
            autoFocus={true}
            TextFieldProps={{
              ...register('platformName', {
                maxLength: 24,
              }),
            }}
          />
        </div>
      )}
    </GetStartedTemplate>
  );
}
